import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from 'context/AuthContext';
import reportWebVitals from 'reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from './components/common/ThemeToggle/ThemeContext';
import Routes from './routes/index';
import { store } from './helpers';
import './assets/scss/main.scss';

// Frame busting script
if (window !== window.top) {
  window.top.location = window.location;
}

// Add a simple loading component
const LoadingSpinner = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}
  >
    <div>Loading...</div>
  </div>
);

ReactDOM.render(
  <AuthProvider>
    <Provider store={store}>
      <ThemeProvider>
        <React.Suspense fallback={<LoadingSpinner />}>
          <Routes />
        </React.Suspense>
      </ThemeProvider>
    </Provider>
  </AuthProvider>,
  document.getElementById('root')
);

reportWebVitals();
serviceWorker.unregister();
